import { Env, Region, getEnv, getRegion } from '@adsk/acs-sc-web-platform-api';

declare global {
  interface Window {
    EXO_INTERNAL_METADATA: {
      currentEnv: Env;
      currentRegion: Region;
    };
  }
}

window.EXO_INTERNAL_METADATA = {
  currentEnv: getEnv(),
  currentRegion: getRegion(),
};
